const FAVORITES_KEY = 'favorites'
const FAVORITE_CURRENCY_KEYS = ['currency', 'currencyCode', 'currency_code', 'country', 'countryCode', 'country_code']
const FAVORITE_LIST_KEYS = ['list', 'items', 'records', 'dataList', 'games', 'gameList', 'game_list']
const GAME_ID_KEYS = ['gid', 'gameId', 'game_id', 'gameCode', 'game_code']
const GAME_ICON_KEYS = ['gameIcon', 'game_icon', 'icon', 'iconUrl', 'icon_url', 'image', 'imageUrl', 'image_url', 'logo']

function firstValue(source, keys) {
  const data = source && typeof source === 'object' ? source : {}
  for (const key of keys) {
    const value = data[key]
    if (value !== undefined && value !== null && String(value).trim() !== '') return value
  }
  return ''
}

function normalizeKey(value) {
  return String(value === undefined || value === null ? '' : value).trim()
}

function favoriteCurrency(group) {
  return normalizeKey(firstValue(group, FAVORITE_CURRENCY_KEYS))
}

function favoriteList(group) {
  const data = group && typeof group === 'object' ? group : {}
  for (const key of FAVORITE_LIST_KEYS) {
    if (Array.isArray(data[key])) return data[key]
  }
  return []
}

function favoriteGid(item) {
  return firstValue(item, GAME_ID_KEYS)
}

function normalizeFavoriteItem(item) {
  if (!item || typeof item !== 'object') return null
  const rawGid = favoriteGid(item)
  if (!normalizeKey(rawGid)) return null
  const normalized = { ...item }
  normalized.gid = typeof rawGid === 'string' ? rawGid.trim() : rawGid
  const icon = firstValue(item, GAME_ICON_KEYS)
  if (icon) normalized.gameIcon = icon
  return normalized
}

function normalizeFavorites(value) {
  if (!Array.isArray(value)) return []
  return value
    .map((group) => {
      if (!group || typeof group !== 'object') return null
      const currency = favoriteCurrency(group)
      if (!currency) return null
      const seenGameIds = new Set()
      const list = favoriteList(group)
        .map(normalizeFavoriteItem)
        .filter(Boolean)
        .filter((item) => {
          const gid = normalizeKey(item.gid)
          if (seenGameIds.has(gid)) return false
          seenGameIds.add(gid)
          return true
        })
      if (!list.length) return null
      return { currency, list }
    })
    .filter(Boolean)
}

export function favoriteItemsForCurrency(favorites, currency) {
  const targetCurrency = normalizeKey(currency)
  if (!targetCurrency) return []
  const group = normalizeFavorites(favorites).find((item) => item.currency === targetCurrency)
  return group ? group.list : []
}

export function isFavoriteGame(favorites, currency, game) {
  const gid = normalizeKey(favoriteGid(game))
  if (!gid) return false
  return favoriteItemsForCurrency(favorites, currency).some((item) => normalizeKey(item.gid) === gid)
}

export function parseFavoritesValue(rawValue) {
  if (!rawValue) return []
  try {
    return normalizeFavorites(JSON.parse(rawValue))
  } catch (e) {
    return []
  }
}

export function safeReadFavorites(storage) {
  if (!storage || typeof storage.getItem !== 'function') return []
  try {
    return parseFavoritesValue(storage.getItem(FAVORITES_KEY))
  } catch (e) {
    return []
  }
}

export function safeSaveFavorites(storage, favorites) {
  if (!storage || typeof storage.setItem !== 'function') return false
  try {
    storage.setItem(FAVORITES_KEY, JSON.stringify(normalizeFavorites(favorites)))
    return true
  } catch (e) {
    return false
  }
}
